/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Treatment card - Update content on selection
  document.querySelectorAll('.treatment__nav-item').forEach(navItem => {
    navItem.addEventListener('click', function () {
      const parent = this.closest('.brick__block__treatment');
      const target = this.dataset.navItem;

      // Update active nav item
      parent.querySelectorAll('.treatment__nav-item').forEach(n => n.classList.remove('active'));
      this.classList.add('active');

      // Update active content block
      parent.querySelectorAll('.treatment__content').forEach(content => {
        content.classList.toggle('active', content.dataset.treatmentItem === target);
      });
    });
  });

  // Prevent Boulevard from opening in a new tab on mobile
  document.querySelectorAll('a[href="#book-now"]').forEach(function(el) {
  el.addEventListener('click', function(e) {
    console.log('Clicked blvd');
    e.preventDefault();
    window.location.hash = 'book-now';
  });
});
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
